import appmaker from '@appmaker/core/index';
import MainDashboard from './routes/Dashboard';
import { Graph } from 'iconsax-reactjs';

const plugin = {
	id: '@appmaker/dashboard',
	name: 'Dashboard',
	activate: () => {
		appmaker.registerRoute({
			routeName: '/',
			component: MainDashboard,
			exact: true,
		});
		/**
		 * Menu Items
		 */
		appmaker.registerSideBarMenu(
			{
				name: 'Dashboard',
				routeName: '/',
				icon: Graph,
			},
			1
		);
	},
};

export default plugin;
